module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.card.title))])]), _vm._v(" "), (_vm.card.id) ? _c('div', [_vm._v("ID "), _c('b', [_vm._v(_vm._s(_vm.card.id))])]) : _vm._e(), _vm._v(" "), (_vm.card.date) ? _c('div', [_vm._v("Date "), _c('b', [_vm._v(_vm._s(_vm.card.date))])]) : _vm._e(), _vm._v(" "), _vm._l((this.card), function(crd, index) {
    return _c('li', {
      key: index,
      attrs: {
        "data-block-id": _vm.card.id
      }
    }, [_c('div', [_vm._v(_vm._s(crd.name))])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fd6849"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/KanbanCard.vue
// module id = 1335
// module chunks = 0